/*
 * @Author: Czy
 * @Date: 2024-09-18 13:44:22
 * @FilePath: /bikecat/src/store/sys.ts
 *
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useSearchStore } from '@/store'
import { adCodeConvert, geocodeConvert } from '@/service/platform-city'
import { PosCityList } from '@/service/home/home.d'

export const useSysStore = defineStore(
  'sys',
  () => {
    const searchKeyWord = ref<string>('北京故宫博物馆') // 搜索框文字
    const isRefreshRp = ref<boolean>(true)
    const refreshObj = ref({
      idx: undefined,
      lowRate: undefined,
      status: true,
    })
    const isOldPage = ref<string>('')
    const setKeyWord = (val?: string) => {
      searchKeyWord.value = val || '北京故宫博物馆'
    }
    const photoWallList = ref<any>([]) // 照片墙
    const roomImageList = ref<any>([]) // 房型图片
    // 获取到的定位信息 默认北京
    const isShowTabbar = ref<boolean>(true) // 是否显示tabbar

    const getFuzzyLocation = (onlyReturn?: boolean) => {
      return new Promise<PosCityList>((resolve, reject) => {
        uni.getLocation({
          type: 'wgs84',
          success: async (res) => {
            console.log('定位最终', res)

            let location = { lon: res.longitude, lat: res.latitude, ver: 1 }

            const { data: hotelData } = await geocodeConvert({
              location: JSON.stringify(location),
            })

            console.log('新版获取位置', hotelData)

            // const amapKey = '8954b00d470c027251aeb0d7c58db47a' // 替换为你的高德地图API Key
            // const url = `https://restapi.amap.com/v3/geocode/regeo?key=${amapKey}&location=${res.longitude},${res.latitude}`

            // uni.request({
            //   url,
            //   success: async (response: any) => {
            //     if (response.data && response.data.regeocode) {
            //       const city = response.data.regeocode.addressComponent.city
            //       const address = city
            //         ? `${response.data.regeocode.addressComponent.city},${response.data.regeocode.addressComponent.township}`
            //         : response.data.regeocode.addressComponent?.country
            //       console.log('高德回来的数据', response.data.regeocode.addressComponent)

            //       const { data: hotelData } = await adCodeConvert({
            //         adCode: response.data.regeocode.addressComponent.adcode,
            //         platformCode: 'ELONG',
            //       })
            //       console.log('hotelData', hotelData)

            //       // const { data: ticketData } = await adCodeConvert({
            //       //   adCode: response.data.regeocode.addressComponent.adcode,
            //       //   platformCode: 'CTRIP_TICKET',
            //       // })

            if (hotelData?.cityId) {
              const hotelItem = {
                regionCode: hotelData?.cityId || '',
                regionName: hotelData?.cityName || '',
                longitude: res.longitude,
                latitude: res.latitude,
                address: hotelData?.address,
                adCode: hotelData?.adCode || '',
                cityId: hotelData?.cityId || '',
              }
              if (!onlyReturn) {
                useSearchStore().hotelCityInfo = hotelItem
              }
              resolve(hotelItem)
            } else {
              reject(`获取位置失败`)
            }
            //     } else {
            //       reject(`高德返回${response?.data?.info}`)
            //     }
            //   },
            //   fail: (error) => {
            //     console.error('获取城市信息失败：', error)
            //     uni.showToast({
            //       icon: 'none',
            //       title: `获取城市信息失败`,
            //     })
            //     reject(error)
            //   },
            // })
          },
          fail: (err) => {
            console.error('获取位置失败：', err)
            uni.showToast({
              icon: 'none',
              direction: 'vertical',
              title: `定位失败,请打开手机定位`,
              // title: `获取定位失败,请打开手机定位权限`,
            })
            reject(err)
          },
        })
      })
    }

    const fetchUserLocation = (onlyReturn?: boolean) => {
      // 检查授权状态
      return new Promise<PosCityList>((resolve, reject) => {
        uni.getSetting({
          success: (res) => {
            if (!res.authSetting['scope.userLocation']) {
              // 未授权，请求授权
              uni.authorize({
                scope: 'scope.userLocation',
                success: () => {
                  // 授权成功，获取位置

                  getFuzzyLocation(onlyReturn)
                    .then((res) => {
                      resolve(res)
                    })
                    .catch(reject)
                },
                fail: () => {
                  useSearchStore().resetHotelCityInfo()
                  // 不再抛出错误，改为记录日志或提示用户
                  console.warn('用户拒绝授权获取位置信息')
                  uni.showToast({
                    icon: 'none',
                    title: '未授权定位,请手动选城市',
                  })
                  reject(new Error('用户拒绝授权'))
                },
              })
            } else {
              // 已授权，直接获取位置
              getFuzzyLocation(onlyReturn)
                .then((res) => {
                  resolve(res)
                })
                .catch(reject)
            }
          },
          fail: (err) => {
            console.error('获取设置失败：', err)
            reject(new Error('获取设置失败'))
          },
        })
      })
    }
    return {
      searchKeyWord,
      setKeyWord,
      isShowTabbar,
      fetchUserLocation,
      photoWallList,
      roomImageList,
      isRefreshRp,
      refreshObj,
      isOldPage,
    }
  },
  {
    persist: true,
  },
)
